module.exports = __webpack_public_path__ + "static/img_create@2x-c011b725896ca1445e7cd6e7d8f28511.png";